// extracted by mini-css-extract-plugin
export var defaultWrapper = "_nt-3";
export var downloadButton = "_nt-4";
export var fileContainer = "_nt-9 _nt-7";
export var fileContainerBase = "_nt-7";
export var fileContainerFixedHeight = "_nt-8 _nt-7";
export var fileInfo = "_nt-5";
export var fileInfoWidthRestricted = "_nt-6";
export var fileType = "_nt-1";
export var fileTypeName = "_nt-2";
export var image = "_nt-0";
export var link = "_nt-b";
export var overflowEllipsis = "_nt-a";